import React from 'react';
import Clock from 'react-live-clock';
import { useNavigate } from 'react-router-dom';

import mapImage from '../images/map.png';
import resourceImage from '../images/udstyr.png';
import logoImage from '../images/customer_logo.png';
import eventsImage from '../images/events.png';

import './Menu.css';

//<div className="menu-point" onClick={() => props.routerActions.navigate('/map')}><img src={mapImage} alt='Map menu' /></div>

const Menu = () => {
    const navigate = useNavigate();

    return (
        <div className="menu">
             <Clock format={'HH:mm'} ticking={true} timezone={'Europe/Copenhagen'} interval={30000}/>
            <div className="menu-point-container">
                <div className="menu-point"><div onClick={() => navigate('/')}><img src={require('../images/home.png')} alt='Hjem menu'/></div></div>
                <div className="menu-point"><div onClick={() => navigate('/plan')}><img src={require('../images/plan.png')} alt='Plan menu'/></div></div>
                <div className="menu-point"><div onClick={() => navigate('/documents')}><img src={require('../images/documents.png')} alt='Arkiv menu'/></div></div>
                {/* <div className="menu-point" onClick={() => navigate('/resource')}><img src={resourceImage} alt='Resource menu' /></div> */}
                <div className="menu-point" onClick={() => navigate('/events')}><img src={eventsImage} alt='events menu' /></div>
                <div className="menu-point" onClick={() => navigate('/externalpage')}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48" fill="none" stroke="#d6e5f7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="menu-icon">
                        <circle cx="24" cy="24" r="20"/>
                        <circle cx="24" cy="24" r="9"/>
                        <line x1="24" y1="14" x2="24" y2="4"/>
                        <line x1="29" y1="15.34" x2="34" y2="6.68"/>
                        <line x1="32.66" y1="19" x2="41.32" y2="14"/>
                        <line x1="34" y1="24" x2="44" y2="24"/>
                        <line x1="32.66" y1="29" x2="41.32" y2="34"/>
                        <line x1="29" y1="32.66" x2="34" y2="41.32"/>
                        <line x1="24" y1="34" x2="24" y2="44"/>
                        <line x1="19" y1="32.66" x2="14" y2="41.32"/>
                        <line x1="15.34" y1="29" x2="6.68" y2="34"/>
                        <line x1="14" y1="24" x2="4" y2="24"/>
                        <line x1="15.34" y1="19" x2="6.68" y2="14"/>
                        <line x1="19" y1="15.34" x2="14" y2="6.68"/>
                    </svg>
                </div>
                <img style={{position: 'absolute', bottom: 0, left: 0, opacity: 0.4, padding: '1vh' }} src={logoImage} alt='' />
            </div>

        </div>
    );
};

export default Menu;